import { ConfigInterface } from 'swr';
import { api, useApi, QueryParams, parseUrl } from '@gik/core/api';
import { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';

const path = 'inkinds';
const per_page = 1000;

function getParams(userId: string): QueryParams {
  return {
    organizerId: userId,
    followerId: userId,
    ownerId: userId,
    per_page,
  };
}

export async function getUserPages(userId: string): Promise<InkindPageAPIModel[]> {
  const finalUrl = parseUrl(path, {
    searchParams: getParams(userId),
  });
  const response = await api.get(finalUrl);
  return await response.json();
}

export function useUserPages(userId?: string, config?: ConfigInterface) {
  // important if there is no slug the path should be null so nothing will be fetched
  return useApi<InkindPageAPIModel[]>(userId ? path : null, config, { searchParams: getParams(userId) });
}

export function getUserOrganizingPages(userId: string) {
  const finalUrl = parseUrl(path, {
    searchParams: { organizerId: userId },
  });
  return api.get(finalUrl);
}

export function useUserOrganizingPages(userId?: string, config?: ConfigInterface) {
  // important if there is no slug the path should be null so nothing will be fetched
  return useApi<InkindPageAPIModel[]>(userId ? path : null, config, {
    searchParams: { organizerId: userId, per_page },
  });
}

export function getUserOwnedPages(userId: string) {
  const finalUrl = parseUrl(path, {
    searchParams: { ownerId: userId },
  });
  return api.get(finalUrl);
}

export function useUserOwnedPages(userId?: string, config?: ConfigInterface) {
  // important if there is no slug the path should be null so nothing will be fetched
  return useApi<InkindPageAPIModel[]>(userId ? path : null, config, {
    searchParams: { ownerId: userId, per_page },
  });
}

export function getUserOwnedOrOrganizingPages(userId: string) {
  const finalUrl = parseUrl(path, {
    searchParams: { organizerId: userId, ownerId: userId },
  });
  return api.get(finalUrl);
}

export function useUserOwnedOrOrganizingPages(userId?: string, config?: ConfigInterface) {
  // important if there is no slug the path should be null so nothing will be fetched
  return useApi<InkindPageAPIModel[]>(userId ? path : null, config, {
    searchParams: { organizerId: userId, ownerId: userId, per_page },
  });
}

export function getUserFollowingPages(userId: string) {
  const finalUrl = parseUrl(path, {
    searchParams: { followerId: userId },
  });
  return api.get(finalUrl);
}

export function useUserFollowingPages(userId?: string, config?: ConfigInterface) {
  // important if there is no slug the path should be null so nothing will be fetched
  return useApi<InkindPageAPIModel[]>(userId ? path : null, config, {
    searchParams: { followerId: userId, per_page },
  });
}
